import BucketApiRequest from "./BucketApiRequest";
import { GET_COUNTRY_URL } from "../ApiUrls";

export default class CountryRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_COUNTRY_URL;
  };
}
